import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate,useParams} from "react-router-dom";
import { Pagination, EffectFade, Autoplay } from "swiper/modules";

import { useTranslation } from "react-i18next";

import swal from 'sweetalert';

import Malebtn from "../assets/male_btn_none.png";
import Femalebtn from "../assets/female_btn_none.png";

import ttsAudio from "../assets/sound/tts_03.mp3"; // mp3 경로 import
import ttsAudio_en from "../assets/sound/en/3.mp3";
import ttsAudio_jp from "../assets/sound/jp/3.mp3";
import ttsAudio_cn from "../assets/sound/cn/3.mp3";
import ttsAudio_mn from "../assets/sound/mn/3.mp3";

const About1_1 = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const { name } = useParams();

    const audioRef = useRef(null);


    const [tody,SetToday]=useState();

    const clickNext= item => {

        navigate('/about1/'+name+'/'+item);
    };

    // 컴포넌트 마운트 시 자동 재생
    useEffect(() => {
        const audio = audioRef.current;
        if (audio) {
            audio.play().catch(err => {
                console.warn("Autoplay failed:", err);
            });
        }
    }, []);

    var lng=i18n.language;

    return (
        <main className="main-container">
            {lng == "ko" && <audio ref={audioRef} src={ttsAudio} autoPlay />}
            {lng == "en" && <audio ref={audioRef} src={ttsAudio_en} autoPlay />}
            {lng == "jp" && <audio ref={audioRef} src={ttsAudio_jp} autoPlay />}
            {lng == "cn" && <audio ref={audioRef} src={ttsAudio_cn} autoPlay />}
            {lng == "mn" && <audio ref={audioRef} src={ttsAudio_mn} autoPlay />}

            <div className="input-area">
                <div className="step_area">STEP 2</div>
                <div className="title_area">
                    <h1 className="num_title">(2/5)</h1>
                    <h2 className="title">{t("성별을 선택해주세요")}</h2>
                </div>

                <div className="input_section" style={{ background: "#ffffff" }}>
                    <div className="flex_area">
                        <ul>
                            <li>
                                {lng === "ko" && <button className="checkBtn male" onClick={() => clickNext("1")}></button>}
                                {lng != "ko" && <button className="checkBtn male" onClick={() => clickNext("1")} style={{ backgroundImage: `url(${Malebtn})` }}></button>}
                            </li>
                            <li>
                                {lng === "ko" && <button className="checkBtn female" onClick={() => clickNext("2")}></button>}
                                {lng != "ko" && <button className="checkBtn female" onClick={() => clickNext("2")} style={{ backgroundImage: `url(${Femalebtn})` }}></button>}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default About1_1;
